import { useMutation, UseMutationResult } from 'react-query';
import { QueryKeys } from '../constants';

import { AxiosError } from 'axios';
import { applyAction, IApplyActionParams } from '../api/actions';

export function useApplyAction(): UseMutationResult<void, AxiosError, IApplyActionParams> {
    return useMutation([QueryKeys.applyAction], (params: IApplyActionParams) => applyAction(params));
}
